import { defineRule } from 'vee-validate'
import * as rules from '@vee-validate/rules'
import { i18n } from './i18n/-i18n'
import { dayjs } from './dayjs'

export default defineNuxtPlugin(() => {
  const store = $store()
  const runtimeConfig = useRuntimeConfig().public

  Object.entries(rules).forEach(([r, v]) => {
    if (typeof v === 'function') {
      // @ts-ignore
      defineRule(r, v)
    }
  })

  defineRule('regexPassword', (value: any) => {
    if (!/(?=.*[a-z])/.test(value)) {
      return 'Ít nhất một chữ cái viết thường'
    }
    if (!/(?=.*[A-Z])/.test(value)) {
      return 'Ít nhất một chữ cái viết hoa'
    }
    if (!/(?=.*[0-9])/.test(value)) {
      return 'Ít nhất 1 chữ số'
    }
    if (!/(?=.*[!@#$%^&*])/.test(value)) {
      return 'Ít nhất có một ký tự đặc biệt'
    }
    if (value.length < 6) {
      return 'Mật khẩu phải có ít nhất 6 ký tự'
    }
    return true
  })
  defineRule('regexName', (value: any) => {
    if (/^(?=.*[0-9]).*$/.test(value)) {
      return i18n.global.t('validations.null_number')
    }
    if (/^(?=.*[!@#$%^&*]).*$/.test(value)) {
      return i18n.global.t('validations.symbol')
    }
    return true
  })
  defineRule('regexPhone', (value: any) => {
    if (!/(((\+|)84)|0)(3|5|7|8|9)+([0-9]{8})\b/.test(value)) {
      return i18n.global.t('validations.number_phone')
    }
    return true
  })
  defineRule('regexEmail', (value: any) => {
    if (value === undefined || value === null || value.trim() === '') {
      return true
    }
    if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
      return i18n.global.t('validations.invalid_email')
    }
    return true
  })
  defineRule('regexTaxNumber', (value: any) => {
    if (!/^[0-9].{9}$/.test(value) && !/^[0-9].{12}$/.test(value)) {
      return i18n.global.t('validations.invalid_tax')
    }
    return true
  })
  defineRule('regexUrl', (value: any) => {
    if (value && value !== '') {
      if (
        !/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi.test(
          value
        )
      ) {
        return i18n.global.t('validations.invalid_url')
      }
    }
    return true
  })
  defineRule('biggerDate', (value: any) => {
    const birthday = new Date(value)
    const today = new Date()
    if (birthday >= today) {
      return i18n.global.t('validations.invalid_date')
    }
    return true
  })
  defineRule('lessDate', (value: any) => {
    const birthday = new Date(value)
    const today = new Date()
    if (birthday < today) {
      return i18n.global.t('validations.invalid_less_date')
    }
    return true
  })
  defineRule('markup', (value: any) => {
    const valueMarkupSetting = store.globalSettings.getGlobalSettings.markup
    if (value < valueMarkupSetting) {
      return i18n.global.t('validations.invalid_markup')
    }
    return true
  })
  defineRule('requiredAutoInput', (value: any) => {
    if (!value && value !== 0) {
      return 'Vui lòng nhập thông tin'
    }
    return true
  })
  defineRule('requiredMinAutoInput', (value: any, number: any) => {
    if (value <= number[0]) {
      return 'Vui lòng nhập giá trị lơn hơn ' + number[0]
    }
    return true
  })
  defineRule('greaterThanToday', (value: any) => {
    if (new Date(value) <= new Date()) {
      return i18n.global.t('validations.greaterThanToday')
    }
    return true
  })
  defineRule('invalidDateFormat', (value: any) => {
    if (new Date(value) > new Date('01/01/10000')) {
      return i18n.global.t('validations.invalidDateFormat')
    }
    return true
  })
  defineRule('requiredMultiple', (value: any, data: any, fieldInfo: any) => {
    const prop = fieldInfo.field
    if (!(Array.isArray(value) && value.length)) {
      return i18n.global.t('validations.required', { field: $t(`labels.${prop}`) })
    }
    return true
  })
  defineRule('min_date', (value: any, data: any, fieldInfo: any) => {
    const prop = fieldInfo.field
    if (new Date(value) < new Date(data[0])) {
      return i18n.global.t('validations.minDate', {
        field: $t(`labels.${prop}`),
        date: data[0]
      })
    }
    return true
  })
  defineRule('date_bigger', (value: any, data: any, fieldInfo: any) => {
    const prop = fieldInfo.field
    if (new Date(value) <= new Date(data[0])) {
      return i18n.global.t('validations.biggerDate', {
        field: $t(`labels.${prop}`),
        date: data[0]
      })
    }
    return true
  })

  defineRule('minValueAuto', (value: any, data: any, fieldInfo: any) => {
    if (Number(value) >= Number(data[0])) {
      return i18n.global.t('validations.minValueAuto', { field: Number(data[0]) })
    }
    return true
  })
  defineRule('gt', (value: any, data: any, fieldInfo: any) => {
    const prop = fieldInfo.field
    if (Number(value) <= Number(data[0])) {
      return i18n.global.t('validations.greaterThan', {
        field: $t(`labels.${prop}`),
        number: data[0]
      })
    }
    return true
  })
  defineRule('gte', (value: any, data: any, fieldInfo: any) => {
    const prop = fieldInfo.field
    if (Number(value) < Number(data[0])) {
      return i18n.global.t('validations.greaterThanOrEqual', {
        field: $t(`labels.${prop}`),
        number: data[0]
      })
    }
    return true
  })
  defineRule('lt', (value: any, data: any, fieldInfo: any) => {
    const prop = fieldInfo.field
    if (Number(value) >= Number(data[0])) {
      return i18n.global.t('validations.lessThan', {
        field: $t(`labels.${prop}`),
        number: data[0]
      })
    }
    return true
  })
  defineRule('lte', (value: any, data: any, fieldInfo: any) => {
    const prop = fieldInfo.field
    if (Number(value) > Number(data[0])) {
      return i18n.global.t('validations.lessThanOrEqual', {
        field: $t(`labels.${prop}`),
        number: data[0]
      })
    }
    return true
  })

  defineRule('checkTimeCompleteTaskTypeVehicle', (value: any, data: any, fieldInfo: any) => {
    if (typeof Number(data[0]) !== 'number') {
      return true
    }
    if (Number(value) < Number(data[0])) {
      return i18n.global.t('validations.checkTimeCompleteTaskTypeVehicle', { hours: data[0] })
    }
    return true
  })

  defineRule('checkTimeCompleteTaskTypeCont', (value: any, data: any, fieldInfo: any) => {
    if (typeof Number(data[0]) !== 'number') {
      return true
    }
    if (Number(value) < Number(data[0])) {
      return i18n.global.t('validations.checkTimeCompleteTaskTypeCont', { hours: data[0] })
    }
    return true
  })

  defineRule('nextDays', (value: any, data: any, fieldInfo: any) => {
    if (!value) {
      return true
    }
    const nameField = fieldInfo.field
    data = data[0].split('-')
    const days = Number(data[0])
    const nameDay = data[1]

    const startDate = dayjs(value).set('hour', 0).set('minute', 1)

    const currentDate = dayjs().startOf('day')

    const endDate = currentDate.add(days, 'day').endOf('day')

    if (!(startDate.isAfter(currentDate) && startDate.isBefore(endDate))) {
      return i18n.global.t(`${nameDay} ≤ ${$t(`labels.${nameField}`)} ≤ ${nameDay} + ${days} (${$t('labels.date')})`)
    }
    return true
  })

  defineRule('validationCustom', (value: any, data: any, fieldInfo: any) => {
    data = data[0].replace('\n', '').split('--')
    const validation = data[0].toString().trim()
    const nofi = data[1].replaceAll('LA==', ',')
    if (validation !== 'true') {
      return nofi
    }
    return true
  })

  defineRule('fileSize', (value: any, [maxSize]: [number], fieldInfo: any) => {
    const prop = fieldInfo.field

    if (!value?.size) {
      return true
    }

    const fileSize = value.size // MB
    let maxFileSize = maxSize * 1024 * 1024

    if (maxFileSize > runtimeConfig.maxFileSize) {
      maxFileSize = runtimeConfig.maxFileSize
    }

    if (Number(fileSize) > Number(maxFileSize)) {
      return `Tệp vượt quá dung lượng cho phép ${maxFileSize / 1024 / 1024} Mb`
      // return i18n.global.t('validations.fileSizeExceeded', {
      //   field: $t(`labels.${prop}`),
      //   maxSize: data[0]
      // })
    }
    return true
  })
})
